import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import classNames from 'classnames';
import { withRouter } from 'react-router';

import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';

import Me from 'cityads-v3/containers/webmaster/profile/Me';
import ClickAwayPopper from 'cityads-v3/components/ClickAwayPopper/ClickAwayPopper';

import classes from './HeaderToolbar.scss';

import {
  USER_ROLE_CODE_MANAGER,
  USER_ROLE_CODE_WEBMASTER,
} from 'cityads-v3/reducers/auth'

const ProfileLink = {
  [USER_ROLE_CODE_MANAGER]: '/main/manager/profile/me',
  [USER_ROLE_CODE_WEBMASTER]: '/publisher/profile/me',
}

@withRouter
@connect(
  state => {
    const owner = state.header.bar.filter(item => item.type === 'owner')[0];
    return {
      user        : state.auth.user,
      isMobile: state.app.isMobile,
      owner,
    }
  }
)
@withTranslation(['main'], { i18n, wait: false })
export default class HeaderUser extends Component {

  static propTypes = {
    user: PropTypes.object,
    authLocation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isMobile: PropTypes.bool,
  }

  state = {
    open: false,
  }

  anchorEl = createRef()

  handleClick = (event) => {
    event.preventDefault();
    this.setState({
      open: true
    });
  }

  closeTimeout = null

  handleRequestClose = () => {
    this.closeTimeout = setTimeout(() => {
      this.setState({
        open: false,
      });
    });
  }

  componentWillUnmount() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  }

  render() {
    const { user, t, authLocation, isMobile, owner } = this.props;

    if (!user) {
      return (
        <Link
          id        = "headerLinkSignIn"
          className = {classNames(classes.item, classes.itemLink, classes.itemSignIn)}
          to        = {authLocation}
        >
          {t('header.sign_in')}
        </Link>
      )
    }

    if (isMobile) {
      return (
        <IconButton
          component={Link}
          to={ProfileLink[user.user_role_code]}
          tooltip={t('header.helpdesk')}
          placement="bottom"
        >
          <AccountCircleOutlinedIcon className={classes.headerIcon} />
        </IconButton>
      );
    }

    return (
      <>
        <span
          ref       = {this.anchorEl}
          onClick   = {this.handleClick}
          className = {classNames(classes.item, classes.dropdownItem, {
            [classes.dropdownItemOpen]: this.state.open
          })}
        >
          <AccountCircleOutlinedIcon className={classNames(classes.headerIcon, classes.dropdownIcon)} />

          <Typography color="textPrimary" variant="caption" className={classes.dropdownItemText}>
            {user.email}
            {owner && owner.data && owner.data.sudo ? (
              ' | ' + owner.data.sudo.substr(0, owner.data.sudo.indexOf('@') + 1) + '…'
            ) : false}
          </Typography>
          <KeyboardArrowDownOutlinedIcon className={classes.arrowDown} />
        </span>
        <ClickAwayPopper
          className = {classes.dropdownItemPopover}
          open      = {this.state.open}
          anchorEl  = {this.anchorEl.current}
          placement = {'bottom-end'}
          onClose   = {this.handleRequestClose}
        >
          <Me />
        </ClickAwayPopper>
      </>
    );
  }
}
